import { WishlistWithItemsEntity } from "@apps/wishlist/entities/WishlistWithItemsEntity";

import { WishlistSdkDto } from "../types";
import { mapWishlistItemToSdkDto } from "./mapWishlistItemToSdkDto";

export function mapWishlistToSdkDto(
    wishlist: WishlistWithItemsEntity
): WishlistSdkDto {
    return {
        id: wishlist.id,
        title: wishlist.title,
        isDefault: wishlist.isDefault,
        isPrivate: wishlist.isPrivate,
        customerId: wishlist.customerId,
        items: wishlist.items.map(mapWishlistItemToSdkDto),
        totalCount: wishlist.totalCount,
    };
}
